import { route } from 'quasar/wrappers';
import {
  createMemoryHistory,
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from 'vue-router';
import routes from './routes';
import { useSession } from 'src/stores/session';
import { api } from 'src/service/api';
import useUpdateChecker from 'src/compositions/UseUpdateChecker';

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default route(function (/* { store, ssrContext } */) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : process.env.VUE_ROUTER_MODE === 'history'
    ? createWebHistory
    : createWebHashHistory;

  const router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.VUE_ROUTER_BASE),
  });

  router.beforeEach((to) => {
    const session = useSession();
    if (!api.isAuthUrl(to.path) && !session.isLoggedIn) {
      session.preLoginUrl = to.path;
      return '/auth/login';
    }
    // this is a simple activity checker: if the user is moving around the app then we know to check for updates
    useUpdateChecker().checkForUpdate(); // could await but we don't care as long as the promise resolves sometime
  });

  return router;
});
